import { render, staticRenderFns } from "./SchoolAccountResetPasswordPage.vue?vue&type=template&id=40fe06b3&scoped=true"
import script from "./SchoolAccountResetPasswordPage.vue?vue&type=script&lang=ts"
export * from "./SchoolAccountResetPasswordPage.vue?vue&type=script&lang=ts"
import style0 from "./SchoolAccountResetPasswordPage.vue?vue&type=style&index=0&id=40fe06b3&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40fe06b3",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/nola-frontend/nola-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('40fe06b3')) {
      api.createRecord('40fe06b3', component.options)
    } else {
      api.reload('40fe06b3', component.options)
    }
    module.hot.accept("./SchoolAccountResetPasswordPage.vue?vue&type=template&id=40fe06b3&scoped=true", function () {
      api.rerender('40fe06b3', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/auth/SchoolAccountResetPasswordPage.vue"
export default component.exports